export default {"src":"/_next/static/media/CSV.c67762b4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};